<template>
    <div
        class="l-ss-c-input-container"
        :class="{
            'l-ss-c-input-container-error': error,
            'l-ss-c-input-container-focus': isFocus
        }">
        <div
            class="l-ss-c-input-wrapper"
            @click.self="focus">
            <div
                class="l-ss-c-input-prefix"
                v-if="$slots.prefix">
                <slot name="prefix"></slot>
            </div>

            <input
                v-if="!hasContentSlot"
                class="l-ss-c-input"
                v-model="inputValue"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                :autofocus="autofocus"
                :disabled="loading"
                :type="type"
                @focus="onFocus"
                @click="$emit('click', $event)"
                @blur="onBlur"
                @input="$emit('native-input', $event)"
                @keydown="$emit('keydown', $event)"
                @mousedown="$emit('mousedown', $event)"
                ref="input">
            <div
                class="l-ss-c-input-custom-content"
                v-if="hasContentSlot">
                <slot name="content"></slot>
            </div>

            <div class="l-ss-c-input-actions">
                <button
                    v-if="allowClear"
                    class="l-ss-c-input-clear"
                    :class="{ 'l-ss-c-input-clear-with-border': hasSuffix }">
                    <i
                        @click="$emit('clear', $event)"
                        v-html="deleteIcon"></i>
                </button>

                <slot name="suffix"></slot>

                <app-btn
                    class="l-ss-c-input-search"
                    v-if="showSearchIcon"
                    :loading="loading"
                    :disabled="disabledSearch"
                    @click="$emit('search', $event)">
                    <i
                        v-html="searchIcon"
                        v-if="!loading"></i>
                </app-btn>
            </div>
        </div>

        <div
            v-if="error"
            class="l-ss-c-input-error-message">
            {{ error }}
        </div>
    </div>
</template>

<script>
    import deleteIcon from '../../assets/images/icons/clear-search-icon.svg';
    import searchIcon from '@/core/assets/images/icons/search-icon.svg';
    import AppBtn from '@/core/components/common/app-btn.vue';

    export default {
        name: 'app-input',
        components: { AppBtn },
        props: {
            value: {
                type: String,
            },
            error: {
                type: String,
            },
            placeholder: {
                type: String,
                default: '',
            },
            showSearchIcon: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
            },
            autocomplete: {
                type: String,
            },
            autofocus: {
                type: Boolean,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            disabledSearch: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isFocus: false,
            };
        },
        computed: {
            inputValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            searchIcon() {
                return searchIcon;
            },
            deleteIcon() {
                return deleteIcon;
            },
            allowClear() {
                return this.clearable && !!this.inputValue;
            },
            hasSuffix() {
                return !!this.$slots?.suffix;
            },
            hasContentSlot() {
                return !!this.$slots.content;
            },
        },
        methods: {
            focus() {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            },
            blur() {
                if (this.$refs.input) {
                    this.$refs.input.blur();
                }
            },
            onFocus(event) {
                this.isFocus = true;
                this.$emit('focus', event);
            },
            onBlur(event) {
                this.isFocus = false;
                this.$emit('blur', event);
            },
        },
    };
</script>
